import './ConnectOrganizationView.scss';

import { DeconstructedURL } from '@sonar-software/sonar-ts-lib';
import { LinkOutlined } from '@ant-design/icons';
import { useSalesforceAuth } from '@hooks';

import { Button, Row, Space } from 'antd';
import { FULL_ROUTES, ONBOARDING_CONNECT_COPY } from '@sonar-software/sonar-ts-constants';
import { GatewayCard, GatewayContent } from '../general';
import { OnboardingStep, OnboardingSteps } from './general';
import React, { useMemo } from 'react';

function getRedirectState() {
	const { subdomain } = new DeconstructedURL(window.location.href);

	return `${subdomain};onboarding`;
}

export const ConnectOrganizationView: React.FC = () => {
	const redirectState = useMemo(getRedirectState, []);
	const { authRedirect, sandboxAuthRedirect } = useSalesforceAuth(FULL_ROUTES.CONFIRM_LINK, redirectState);

	return (
		<GatewayContent>
			<GatewayCard
				className='connect-org-view'
				pre={ <OnboardingSteps currentStep={ OnboardingStep.Connect } /> }
				title={ ONBOARDING_CONNECT_COPY.CONNECT_YOUR_ORGANIZATION }>
				<p>{ ONBOARDING_CONNECT_COPY.CONNECT_DIALOG }</p>
				<br />
				<br />
				<Row justify='center'>
					<Space size={ 4 }>
						<Button
							id='connect-salesforce-sandbox-button'
							onClick={ sandboxAuthRedirect }
							size='large'>
							<LinkOutlined /> { ONBOARDING_CONNECT_COPY.CONNECT_NEW_SANDBOX }
						</Button>
						<Button
							id='connect-salesforce-button'
							onClick={ authRedirect }
							size='large'
							type='primary'>
							<LinkOutlined /> { ONBOARDING_CONNECT_COPY.CONNECT_NEW_SALESFORCE }
						</Button>
					</Space>
				</Row>
			</GatewayCard>
		</GatewayContent>
	);
};
